import { useWeb3, useSwitchNetwork } from "@3rdweb/hooks";

export { useWeb3, useSwitchNetwork };
